export const GET_ORG_DATA = "GET_ORG_DATA";
export const GET_ORG_DATA_BANNA = "GET_ORG_BANNA";
export const COMPANY_DATA_UPDATE = "COMPANY_DATA_UPDATE";
